/* eslint-disable */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';

import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';

import { useTranslation } from 'react-i18next';
import { AlertAdapter, CustomCheckBox, Label } from 'pg-ui-library';
import BenefitsService from 'src/services/benefits.service';
import { useQuery } from '@tanstack/react-query';

import { useActions } from 'src/hooks/useActions';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';
import { BenefitSettingsType, CommuterSettings, IBenefit, ICartBenefit } from 'src/interfaces';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { DefaultSwitch } from 'src/components/default-switch';
import { removeForbiddenWords } from 'src/utils/removeForbiddenWords';
import { removeBenefitFromCart } from 'src/state/action-creators';

import EnrollSelectionCard from '../enroll-selection-card';
import {
  CloseIcon,
  Content,
  FormTitle,
  Header,
  GridContainer,
  ButtonContainer,
  FormButton,
  SwitchContainer,
  PreviousIcon,
  NextIcon,
  SmokerOptionAlert,
} from './styles';
import EnrollCard from '../enroll-card';
import {
  useBenefitEnrollSelectionModalIsOpen,
  useBenefitType,
  useSetBenefitEnrollSelectionModal,
  useSmoker,
  useSetSmoker,
} from '../../enrollment.context';
import { BenefitEventType, benefitTypeAlias } from '../..';
import { SettingsModal } from '../settings-modal';

function useVolLife(availableBenefits: IBenefit[] | undefined, cart: ICartBenefit[] | undefined) {
  const [newAvailableBenefits, setNewAvailableBenefits] = useState(availableBenefits);
  const [loading, setLoading] = useState(false);

  const handleSpendingAccounts = () => {
    setLoading(true);
    const notEnrollableList: string[] = [];
    const filteredCart = cart?.filter(b => b.action === 'ADD');

    if (filteredCart?.length) {
      const electedChildPlan = filteredCart.find(b => b.benefitId === 'LIFE_CH');
      const electedEmployeePlan = filteredCart.find(b => b.benefitId === 'LIFE_EE');
      const electedSpousePlan = filteredCart.find(b => b.benefitId === 'LIFE_SP');

      if (!electedChildPlan) {
        notEnrollableList.push('VOLADD_CH');
      }

      if (!electedEmployeePlan) {
        notEnrollableList.push('VOLADD_EE');
      }
      if (!electedSpousePlan) {
        notEnrollableList.push('VOLADD_SP');
      }
    } else {
      notEnrollableList.push('VOLADD_CH');
      notEnrollableList.push('VOLADD_EE');
      notEnrollableList.push('VOLADD_SP');
    }

    if (notEnrollableList.length > 0) {
      const notEnrollableStringList = notEnrollableList.join(',');
      const filteredBenefits = availableBenefits?.filter((benefit: IBenefit) => {
        if (notEnrollableStringList.includes(benefit.benefitId)) {
          return false;
        }
        return true;
      });
      setLoading(false);
      setNewAvailableBenefits(filteredBenefits);
    } else {
      setLoading(false);
      setNewAvailableBenefits(availableBenefits);
    }
  };

  useEffect(() => {
    handleSpendingAccounts();
  }, [availableBenefits, cart]);

  return { newAvailableBenefits, loading };
}

function useSpendingAcounts(availableBenefits: IBenefit[] | undefined, cart: ICartBenefit[] | undefined) {
  const wordsToClear = ['FAM', 'EE', 'ES', 'EC'];

  const [newAvailableBenefits, setNewAvailableBenefits] = useState(availableBenefits);
  const [loading, setLoading] = useState(false);

  const handleSpendingAccounts = () => {
    setLoading(true);
    const notEnrollableList: string[] = [];
    const filteredCart = cart?.filter(b => b.action === 'ADD');

    if (filteredCart?.length) {
      const electedLowMedicalPlan = filteredCart.find(b => b.planDescription === 'Base Plan-Internal');
      const electedMidMedicalPlan = filteredCart.find(b => b.planDescription === 'Mid Plan-Internal');
      const electedHighMedicalPlan = filteredCart.find(b => b.planDescription === 'High Plan-Internal');

      // Can elect HSA or FSA; DCA
      if (!electedLowMedicalPlan || !electedMidMedicalPlan || !electedHighMedicalPlan) {
        filteredCart.forEach(b => {
          if (b.benefitId.includes('HSA')) {
            notEnrollableList.push('FSA');
          } else if (b.benefitId.includes('FSA')) {
            notEnrollableList.push('HSA');
          }
        });
      }

      // Can elect HSA or FSA; DCA
      if (electedLowMedicalPlan) {
        filteredCart.forEach(b => {
          if (b.benefitId.includes('HSA')) {
            notEnrollableList.push('FSA');
          } else if (b.benefitId.includes('FSA')) {
            notEnrollableList.push('HSA');
          }
        });
      }
      // Can elect FSA, DCA
      if (electedMidMedicalPlan || electedHighMedicalPlan) {
        notEnrollableList.push('HSA');
      }
    }

    if (notEnrollableList.length > 0) {
      const notEnrollableStringList = notEnrollableList.join(',');
      const filteredBenefits = availableBenefits?.filter((benefit: IBenefit) => {
        if (notEnrollableStringList.includes(removeForbiddenWords(benefit.benefitId, wordsToClear))) {
          return false;
        }
        return true;
      });
      setNewAvailableBenefits(filteredBenefits);
      setLoading(false);
    } else {
      setNewAvailableBenefits(availableBenefits);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSpendingAccounts();
  }, [availableBenefits, cart]);

  return { newAvailableBenefits, loading };
}

export enum ModalState {
  SELECTION_STATE = 'SELECTION_STATE',
  ENROLLMENT_STATE = 'ENROLLMENT_STATE',
  SETTINGS_STATE = 'SETTINGS_STATE',
}

export const EnrollSelectionModal: React.FC<{
  eventType: BenefitEventType;
}> = ({ eventType }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { addBenefitToCart } = useActions();

  const isOpen = useBenefitEnrollSelectionModalIsOpen();
  const setIsOpen = useSetBenefitEnrollSelectionModal();
  const selectedBenefitType = useBenefitType();

  const [selectedPlan, setSelectedPlan] = useState<string>();
  const [selectedBenefit, setSelectedBenefit] = useState<IBenefit>();
  const [enableSmokerOption, setEnableSmokerOption] = useState<boolean>(false);
  const setSmoker = useSetSmoker();
  const [modalState, setModalState] = useState<string>(ModalState.SELECTION_STATE);
  const { t } = useTranslation();
  const { cart, benefits } = useTypedSelector(state => state.benefits.data);
  const smoker = useSmoker();
  const [settingsOpen, setOpenSettings] = useState(false);
  const { getBenefits } = useActions();
  const [hasDataError, setHasDataError] = useState(false);
  const [missingDataMessage, setMissingDataMessage] = useState<string>('');

  const extractMissingDataFromError = (errorMessage: string): string => {
    // Tentar extrair a informação específica que está faltando da mensagem
    // Suporta tanto "Missing required employee data:" quanto "Missing benefit configuration:"
    const employeeDataMatch = errorMessage.match(/Missing required employee data: (.+?)\./);
    const benefitConfigMatch = errorMessage.match(/Missing benefit configuration: (.+?)\./);

    if (employeeDataMatch) {
      return employeeDataMatch[1];
    }
    if (benefitConfigMatch) {
      return benefitConfigMatch[1];
    }

    // Se não encontrar padrão específico, retorna a mensagem completa até o ponto final
    const genericMatch = errorMessage.match(/(.+?)\./);
    return genericMatch ? genericMatch[1] : errorMessage;
  };

  const {
    data: planDescriptions,
    refetch: loadPlansByType,
    isFetching: loadingPlansByType,
    isError: planDescriptionsHasError,
  } = useQuery({
    queryKey: ['benefits/availableByType'],
    queryFn: () => BenefitsService.getAvailablePlanDescriptionByType(selectedBenefitType ?? '', eventType),
    enabled: false,
    retry: false,
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || '';
      const statusCode = error?.response?.status;

      if (statusCode === 422) {
        // UnprocessableEntityException - dados faltando
        setHasDataError(true);
        const missingData = extractMissingDataFromError(errorMessage);
        setMissingDataMessage(missingData);
      }
    },
  });

  const {
    data: availableBenefits,
    refetch: loadAvailableBenefits,
    isFetching: loadingAvailableBenefits,
    isError,
  } = useQuery({
    queryKey: ['benefits/availableByDescription'],
    queryFn: () =>
      BenefitsService.getAvailableBenefits({
        planDescription: selectedPlan as string,
        eventType,
        type: selectedBenefitType as string,
        smoker: smoker ? 'true' : 'false',
      }),
    enabled: false,
    retry: false,
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || '';
      const statusCode = error?.response?.status;

      if (statusCode === 422) {
        // UnprocessableEntityException - dados faltando ou configuração faltando
        const missingData = extractMissingDataFromError(errorMessage);
        console.log('Error 422 detected - Third Step:', { errorMessage, missingData, statusCode });
        setHasDataError(true);
        setMissingDataMessage(missingData);
      }
    },
  });

  useEffect(() => {
    getBenefits();
  }, []);

  useEffect(() => {
    setSmoker(false);
    setHasDataError(false);
    setMissingDataMessage('');
  }, [isOpen]);

  useEffect(() => {
    if (selectedBenefitType && isOpen && selectedPlan) {
      if (modalState === ModalState.ENROLLMENT_STATE) {
        loadAvailableBenefits();
      }
    }
  }, [selectedBenefitType, selectedPlan, modalState, smoker]);

  // Skip first step if we have just one plan
  useEffect(() => {
    if (planDescriptions && !loadingPlansByType && !hasDataError) {
      if (planDescriptions?.length > 0 && planDescriptions?.length < 2) {
        setSelectedPlan(planDescriptions[0].planDescription);
        setEnableSmokerOption(planDescriptions[0].enableSmokeOption);
        setModalState(ModalState.ENROLLMENT_STATE);
      }
    }
  }, [planDescriptions, loadingPlansByType, hasDataError]);

  useEffect(() => {
    if (selectedBenefitType && isOpen) {
      setModalState(ModalState.SELECTION_STATE);
      loadPlansByType();
    }
  }, [selectedBenefitType, isOpen]);

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  const handleModal = () => {
    if (isOpen) {
      setSelectedPlan(undefined);
      setSelectedBenefit(undefined);
    }

    setIsOpen(!isOpen);
  };

  const handleMedicalPlansWithHSA = () => {
    const wordsToClear = ['FAM', 'EE', 'ES', 'EC'];
    const filteredCart = cart?.filter(b => b.action === 'ADD');

    const electedMidMedicalPlan = selectedBenefit?.planDescription === 'Mid Plan-Internal';
    const electedHighMedicalPlan = selectedBenefit?.planDescription === 'High Plan-Internal';
    const electedMidOap = selectedBenefit?.planDescription === 'Mid OAP Plan';

    if (!electedMidMedicalPlan && !electedHighMedicalPlan) return;
    if (!electedMidOap && !electedMidOap) return;

    if (filteredCart?.length) {
      const electedHSA = filteredCart.find(b => b.benefitId.includes(removeForbiddenWords('HSA', wordsToClear)));

      // if we have HSA on cart we need to remove and mark as declined
      if (electedHSA) {
        AlertAdapter('HSA was marked as declined', 'warning');
        // Removing the HSA
        removeBenefitFromCart(electedHSA);

        const declinedBenefit: ICartBenefit = {
          generalCategory: '',
          type: electedHSA.type || '',
          benefitId: '',
          imgURL: '',
          planDescription: electedHSA.type || '',
          optionDescription: 'Declined',
          price: 0,
          expiration: '',
          action: 'DECLINED',
          benefitName: electedHSA.type || '',
          benefitPlanId: '',
          benefitOptionId: '',
          benefitEnrollmentStart: '',
          benefitEnrollmentEnd: '',
          benefitProvider: '',
          employeeName: '',
          employeeCost: 0,
          employerName: '',
          employerCost: 0,
          percent: 0,
          fixedAmount: 0,
          dependents: '',
          employeeChoosesPayment: null,
        };
        // Add as declined
        addBenefitToCart({ ...declinedBenefit });
      }
    }
  };

  const handleOnClick = () => {
    if (modalState === ModalState.SELECTION_STATE) {
      if (!selectedPlan) {
        AlertAdapter('You need to select a plan to continue', 'warning');
        return;
      }

      if (hasDataError) {
        AlertAdapter('Cannot proceed due to missing employee data. Please contact support.', 'error');
        return;
      }

      setModalState(ModalState.ENROLLMENT_STATE);
    } else {
      if (!selectedBenefit) {
        AlertAdapter('You need to select a benefit to continue', 'warning');
        return;
      }

      handleMedicalPlansWithHSA();

      setOpenSettings(true);
    }
  };

  const { newAvailableBenefits: availableSpendingAccounts, loading: spendingAccountsLoading } = useSpendingAcounts(
    availableBenefits,
    cart
  );
  // eslint-disable-next-line prefer-const
  let { newAvailableBenefits: filteredAvailableBenefits, loading: filteredBenefitsLoading } = useVolLife(
    availableSpendingAccounts,
    cart
  );

  if (isError) {
    filteredAvailableBenefits = [];
  }

  const canEnroll = () => {
    if (hasDataError) {
      return true; // Desabilita se houver erro
    }
    if (filteredAvailableBenefits && selectedBenefit?.enrollable) {
      return filteredAvailableBenefits.length <= 0;
    }
    return true;
  };

  const canShowDownload = () => {
    if (availableBenefits && availableBenefits.length > 0) {
      const firstBenefit = availableBenefits[0];
      if (firstBenefit && firstBenefit.hasPlanDocument && firstBenefit.hasPlanDocument > 0) {
        return false;
      }
    }
    return true;
  };

  const handleDecline = () => {
    const declinedBenefit: ICartBenefit = {
      generalCategory: '',
      type: selectedBenefitType || '',
      benefitId: '',
      imgURL: '',
      planDescription: selectedBenefitType || '',
      optionDescription: 'Declined',
      price: 0,
      expiration: '',
      action: 'DECLINED',
      benefitName: selectedBenefitType || '',
      benefitPlanId: '',
      benefitOptionId: '',
      benefitEnrollmentStart: '',
      benefitEnrollmentEnd: '',
      benefitProvider: '',
      employeeName: '',
      employeeCost: 0,
      employerName: '',
      employerCost: 0,
      percent: 0,
      fixedAmount: 0,
      dependents: '',
      employeeChoosesPayment: null,
    };
    addBenefitToCart({ ...declinedBenefit });
    AlertAdapter('You declined this option', 'success');
    handleModal();
  };

  const showSmokerOption = filteredAvailableBenefits?.find(value => value.ignoreSmokerFilter === false);

  const handleSettingsModal = (modifiedBenefit: IBenefit) => {
    setOpenSettings(false);
    setSelectedBenefit(modifiedBenefit);

    const isExistingLifeEE =
      modifiedBenefit.benefitId === 'LIFE_EE' &&
      (cart ?? []).some(
        benefit => benefit.benefitId === 'LIFE_EE' && benefit.action !== 'REMOVE' && benefit.action !== 'DECLINED'
      );

    addBenefitToCart({
      ...modifiedBenefit,
      action: 'ADD',
      hasSmokerOption: !!showSmokerOption,
      smoker,
    });

    if (isExistingLifeEE) {
      AlertAdapter(
        'The coverage amount elected for Voluntary AD&D must match the coverage amount elected for Voluntary Life. As per plan regulations, different coverage amounts are not permitted. Please ensure that both elections reflect the same coverage amount before proceeding.',
        'warning'
      );
    } else {
      AlertAdapter('Benefit added to the cart', 'success');
    }

    handleModal();
  };

  const handleDocDownload = () => {
    if (availableBenefits && availableBenefits.length > 0) {
      const firstBenefit = availableBenefits[0];
      if (firstBenefit?.versionId) {
        return BenefitsService.planDocDownload(
          firstBenefit?.versionId || '',
          firstBenefit?.planDocument || '',
          firstBenefit?.type || ''
        );
      }
    }
  };

  useEffect(() => {
    setSelectedBenefit(undefined);
    // loadAvailableBenefits();
  }, [smoker, eventType]);

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '650px',
          height: '600px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '45px',
          overflowY: 'hidden',
          overflowX: 'hidden',
        },
      }}
    >
      <Header>
        <FormTitle>{benefitTypeAlias(selectedBenefitType as string)}</FormTitle>
        <CloseIcon src={closeSvg} onClick={() => handleModal()} />
      </Header>
      {loadingPlansByType || loadingAvailableBenefits || spendingAccountsLoading || filteredBenefitsLoading ? (
        <Content>
          <GridContainer>
            <EnrollSelectionCard
              key="0"
              imgURL=""
              title="Loading..."
              contentTitle=""
              contentText=""
              selected={false}
              onSelect={() => {}}
            />
          </GridContainer>
          <ButtonContainer>
            {modalState === ModalState.SELECTION_STATE ? (
              <FormButton onClick={() => {}} disabled>
                {t('global.form.continue')}
              </FormButton>
            ) : (
              <FormButton onClick={() => {}} disabled>
                {t('global.form.enroll')}
              </FormButton>
            )}
          </ButtonContainer>
        </Content>
      ) : (
        <Content>
          {settingsOpen && (
            <SettingsModal
              isOpen={settingsOpen}
              setIsOpen={setOpenSettings}
              benefit={selectedBenefit as IBenefit}
              onSubmit={benefit => {
                handleSettingsModal(benefit);
              }}
            />
          )}
          {hasDataError && modalState === ModalState.SELECTION_STATE ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: '40px 20px',
                gap: '15px',
              }}
            >
              <div
                style={{
                  fontSize: '48px',
                  color: '#ff9800',
                }}
              >
                ⚠️
              </div>
              <div
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#333',
                  textAlign: 'center',
                }}
              >
                Missing Required Information
              </div>
              <div
                style={{
                  fontSize: '13px',
                  color: '#666',
                  textAlign: 'center',
                  maxWidth: '400px',
                }}
              >
                {missingDataMessage}
              </div>
              <div
                style={{
                  fontSize: '13px',
                  color: '#666',
                  textAlign: 'center',
                  marginTop: '5px',
                }}
              >
                Please contact support to update your employee information.
              </div>
            </div>
          ) : modalState === ModalState.SELECTION_STATE ? (
            <div style={{ display: 'flex' }}>
              {planDescriptions && planDescriptions.length > 0 ? (
                <GridContainer ref={containerRef}>
                  {planDescriptions?.map((plan, index) => (
                    <EnrollSelectionCard
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${plan.planDescription}-${index}`}
                      imgURL={plan.imgURL}
                      title={plan.planDescription}
                      contentTitle=""
                      contentText=""
                      selected={selectedPlan === plan.planDescription}
                      onSelect={() => {
                        setSelectedPlan(plan.planDescription);
                        setEnableSmokerOption(plan.enableSmokeOption);
                      }}
                    />
                  ))}
                </GridContainer>
              ) : (
                <div style={{ marginLeft: '13%', textAlign: 'center' }}>{t('benefits.benefit.nonAvailables')}</div>
              )}
            </div>
          ) : null}
          {modalState === ModalState.ENROLLMENT_STATE && (
            <>
              {hasDataError ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    padding: '40px 20px',
                    gap: '15px',
                  }}
                >
                  <div
                    style={{
                      fontSize: '48px',
                      color: '#ff9800',
                    }}
                  >
                    ⚠️
                  </div>
                  <div
                    style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#333',
                      textAlign: 'center',
                    }}
                  >
                    Missing Required Information
                  </div>
                  <div
                    style={{
                      fontSize: '13px',
                      color: '#666',
                      textAlign: 'center',
                      maxWidth: '400px',
                    }}
                  >
                    {missingDataMessage}
                  </div>
                  <div
                    style={{
                      fontSize: '13px',
                      color: '#666',
                      textAlign: 'center',
                      marginTop: '5px',
                    }}
                  >
                    Please contact support to update your employee information.
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display: 'flex', minHeight: '30px' }}>
                    {showSmokerOption ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          flex: '1',
                        }}
                      >
                        <SmokerOptionAlert>Please select the appropriate option if you are a smoker</SmokerOptionAlert>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <p style={{ marginTop: '5px' }}>{t('benefits.benefit.smokerOptions')}</p>
                          <DefaultSwitch
                            checked={smoker}
                            isLoading={false}
                            onChange={() => {
                              setSmoker(!smoker);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div style={{ display: 'flex' }}>
                    <GridContainer ref={containerRef}>
                      {(filteredAvailableBenefits?.length as unknown as 0) > 0 ? (
                        // eslint-disable-next-line no-confusing-arrow
                        filteredAvailableBenefits?.map(benefit =>
                          benefit.price === 0 ||
                          benefit.employeeChoosesPayment === 'Yes' ||
                          benefit.costCalculationMethod?.toLocaleLowerCase() === 'fixed' ||
                          benefit.costCalculationMethod?.toLocaleLowerCase() === 'table' ||
                          benefit.costCalculationMethod?.toLocaleLowerCase() === 'free' ? (
                            <EnrollCard
                              key={benefit.benefitId}
                              imgURL={benefit.imgURL}
                              title={benefit.planDescription}
                              enrollable={benefit.enrollable}
                              subtitle={benefit.dependentsDescription ?? ''}
                              fee={monetaryUSDFormat(benefit.price)}
                              coverage={
                                benefit.coverageAmount ? monetaryUSDFormat(benefit.coverageAmount as number) : ''
                              }
                              selected={benefit.benefitId === selectedBenefit?.benefitId}
                              onSelect={() => setSelectedBenefit(benefit)}
                              employeeChoosesPayment={
                                (benefit.settings?.data as CommuterSettings)?.employeeChoosesPayment
                              }
                              costCalculationMethod={benefit.costCalculationMethod}
                            />
                          ) : (
                            ''
                          )
                        )
                      ) : (
                        <div style={{ marginLeft: '13%', textAlign: 'center' }}>
                          {t('benefits.benefit.nonAvailables')}
                        </div>
                      )}
                    </GridContainer>
                  </div>
                </>
              )}
            </>
          )}
          <ButtonContainer>
            {modalState === ModalState.SELECTION_STATE ? (
              <FormButton onClick={() => handleOnClick()} disabled={!selectedPlan || hasDataError}>
                {t('global.form.continue')}
              </FormButton>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flex: '1',
                  justifyContent: 'space-between',
                }}
              >
                <FormButton onClick={() => setModalState(ModalState.SELECTION_STATE)}>
                  {t('global.button.back')}
                </FormButton>
                <div>
                  <FormButton disabled={canShowDownload()}>
                    {canShowDownload() ? (
                      <span>{t('global.form.downloadDoc')}</span>
                    ) : (
                      <a href={handleDocDownload()} download target="_blank" rel="noreferrer">
                        {t('global.form.downloadDoc')}
                      </a>
                    )}
                  </FormButton>
                  <FormButton onClick={() => handleDecline()}>{t('global.form.waive')}</FormButton>
                  <FormButton onClick={() => handleOnClick()} disabled={canEnroll()}>
                    {t('global.form.enroll')}
                  </FormButton>
                </div>
              </div>
            )}
          </ButtonContainer>
        </Content>
      )}
    </ReactModal>
  );
};
